import { TFunction } from 'i18next'
import SolrConfigRestService from '../rest/SolrConfigRestService'

class SolrConfigService {
  static async getSolrConfig() {
    return SolrConfigRestService.getSolrConfig()
  }

  static async updateSolrConfig(solrConfig: any, t: TFunction, setSolrConfig: React.Dispatch<any>) {
    try {
      var config = Object.assign({}, solrConfig)
      if (solrConfig.tlsEnabled === false) {
        config.keyId = ''
        config.certId = ''
        config.sslKey = ''
      }
      config.zookeeperHosts = solrConfig.zookeeperHosts?.split(',').map((zookeeperHost: string) => zookeeperHost.trim())
      config.solrUrls = solrConfig.solrUrls?.split(',').map((solrUrl: string) => solrUrl.trim())
      const updatedConfig = await SolrConfigRestService.updateSolrConfig(config)
      setSolrConfig(updatedConfig)
      return t('solrConfig.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteSolrConfig(t: TFunction, setSolrConfig: React.Dispatch<any>) {
    try {
      await SolrConfigRestService.deleteConfig()
      const solrConfig = await SolrConfigService.getSolrConfig()
      setSolrConfig(solrConfig)
      return t('solrConfig.deleteSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getConnection() {
    try {
      return await SolrConfigRestService.testConnection()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getCollections() {
    try {
      const connection = await SolrConfigRestService.testConnection()
      return connection.solrCollections
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default SolrConfigService
